import React, { Component } from 'react';
import {uxRedirect} from "../shared/actions/ux";
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import Header from '../shared/components/layout/Header';
import Content from '../shared/components/layout/Content';
import Footer from '../shared/components/layout/Footer';
import './App.css';

class AsyncApp extends Component {
    static propTypes = {
        redirectTo: PropTypes.string,
        children: PropTypes.element
    }

    redirectTo = null

    componentWillReceiveProps(nextProps) {
        if (nextProps.redirectTo && nextProps.redirectTo !== this.props.redirectTo){
            this.redirectTo = nextProps.redirectTo;
            this.props.dispatch(uxRedirect(null));
        }
    }

    render() {
        if (this.redirectTo){
            let result = <Redirect to={this.redirectTo} />
            this.redirectTo = null;
            return result;
        }
        return (
            <div className="ac-app">
                <Header />
                <Content>
                    {this.props.children}
                </Content>
                <Footer />
            </div>
        );
    }
};

function mapStateToProps(state) {
    if (state.meta) {
        if (state.meta.friendlyName) {
            document.title = state.meta.friendlyName;
        }
    }
    return {
        redirectTo: state.ux.redirectTo
    };
}
export default connect(mapStateToProps)(AsyncApp);